import { Warning } from '@mui/icons-material'
import { Badge } from '@mui/material'
import { useOperationsStore } from '@tom-ui/operations'
import { usePlanningStore } from '@tom-ui/planning'
import { useYardStores } from '@tom-ui/yard'
import { observer } from 'mobx-react-lite'
import { useEffect, useMemo } from 'react'

export const IssueMenuIcon = observer(() => {
  const { issueItemStore } = usePlanningStore()
  const { issueUIStore } = useOperationsStore()
  const { yardIssueUIStore } = useYardStores()

  useEffect(() => {
    issueItemStore.fetch()
    issueUIStore.fetch()
    yardIssueUIStore.fetch()
  }, [issueItemStore, issueUIStore, yardIssueUIStore])

  const totalIssueCount = useMemo(
    () =>
      issueItemStore.notResolvedItemsWithObjectTypeOrder.length +
      issueItemStore.notResolvedItemsWithObjectTypeContainer.length +
      issueUIStore.unresolvedIssues.length +
      yardIssueUIStore.unresolvedIssues.length,
    [
      issueItemStore.notResolvedItemsWithObjectTypeOrder.length,
      issueItemStore.notResolvedItemsWithObjectTypeContainer.length,
      issueUIStore.unresolvedIssues.length,
      yardIssueUIStore.unresolvedIssues.length,
    ],
  )

  return (
    <Badge badgeContent={totalIssueCount} color='warning'>
      <Warning />
    </Badge>
  )
})
